import { render, staticRenderFns } from "./FormToOrganizations.vue?vue&type=template&id=29501755&scoped=true&"
import script from "./FormToOrganizations.vue?vue&type=script&lang=js&"
export * from "./FormToOrganizations.vue?vue&type=script&lang=js&"
import style0 from "./FormToOrganizations.vue?vue&type=style&index=0&id=29501755&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29501755",
  null
  
)

export default component.exports